import Ajax from '../ajax';

export default {
  sso: () => Ajax('get', 'api/token'),
  getToken: (code) => Ajax('post', `api/token?code=${code}`),
  signOut: (token) => Ajax('get', 'api/token/signOut', { token }),
};
